
export function moveElement<T>(arr: T[], oldIndex: number, newIndex: number): T[] {
    if (oldIndex === newIndex || newIndex > arr.length -1) {
        return arr;
    }
    if (newIndex < oldIndex) {
        newIndex++;
    }
    if (newIndex == oldIndex) {
        return arr;
    }
    const element = arr.splice(oldIndex, 1)[0];
    arr.splice(newIndex, 0, element);
    return arr;
};

export function addElement<T>(arr: T[], element: T, index: number): T[] {
    let startIndex = index;
    if (index < 0) {
        startIndex = 0;
    }
    if (index >= arr.length) {
        arr.push(element);
    } else {
        arr.splice(startIndex, 0, element);
    }
    return arr;
};